import styled from "styled-components";
import { getTypographyFontStyle, colors } from "../../styles/global.style";

export const AccordionWrapper = styled.div`
  border-bottom: 1px solid ${colors.border};
  border-left: 3px solid
    ${({ $isActive }) => ($isActive ? colors.primary : "transparent")};
  padding: 1rem 0 1rem 1rem;
  transition: all 0.3s ease;
  margin-bottom: 4px;
  border-radius: 4px 0 0 4px;

  &:hover {
    background: rgba(19, 88, 150, 0.02);
  }
`;

export const AccordionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  gap: 16px;
`;

export const AccordionAction = styled.div`
  font-size: 1.5rem;
  color: ${colors.primary};
  user-select: none;
  transition: transform 0.3s ease;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(19, 88, 150, 0.06);
  transform: ${({ $isActive }) => ($isActive ? "rotate(180deg)" : "rotate(0deg)")};
`;

export const AccordionContent = styled.div`
  max-height: ${({ $isActive }) => ($isActive ? "1000px" : "0")};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
  margin-top: ${({ $isActive }) => ($isActive ? "0" : "-0.75rem")};
  transition: all 0.4s ease-in-out;
  overflow: hidden;
`;

export const AccordionDescription = styled.p`
  ${getTypographyFontStyle({ variant: "body1", weight: 400 })};
  color: ${colors.lightdark};
  margin-top: 0.75rem;
  line-height: 1.7;
`;
